import axios from "axios"
import { Dispatch } from "redux"
import {AUTH_URL } from "../constants"
import { META_DATA_FAIL, META_DATA_REQUEST, META_DATA_SUCCESS } from "../constants/metaConstants"


export const getMetaData = ()=> async(dispatch: Dispatch)=>{
    try {

        dispatch({type: META_DATA_REQUEST})

        const {data} = await axios.get(`${AUTH_URL}/meta-data`, {withCredentials: true})

        dispatch({type: META_DATA_SUCCESS, payload: data})
        
    } catch (error:any) {

        dispatch({type: META_DATA_FAIL, payload: error.response && error.response.data.message ? error.response.data.message : error.message})
    }
}